import React from "react";
import { Redirect, Route, Switch, asyncComponent } from "../../../components";
const Customers = ({ match }) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/edit`} />
        <Route
          path={`${match.url}/edit`}
          component={asyncComponent(() => import("./routes/profile"))}
        />
        <Route
          path={`${match.url}/password-update`}
          component={asyncComponent(() =>
            import("./routes/Components/PasswordUpdate")
          )}
        />
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default Customers;
